/* Store Vuex and General Components */
import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import Search from './components/layout/Search'
import Users from "./services/Users"
import cookie from "vue-cookie"
/* Sales Channels Routes */
import AllSalesChannel from './components/salesChannel/AllSalesChannel'
import ModifySalesChannel from './components/salesChannel/Modify'

/* Users Routes */
import AllUsers from './components/users/AllUsers'
import ForgotPassword from './components/users/ForgotPassword'
import ReinitializationPassword from './components/users/ReinitializationPassword'
import Login from './components/users/Login'
import ModifyPassword from '@/components/users/ModifyPassword'

/* Products Routes */
import AllProducts from './components/products/AllProducts'
import CreateProduct from './components/products/CreateProduct'

/* Profiles Routes */
import AllProfiles from './components/profiles/AllProfiles'

/* Campaign Routes */
import AllCampaigns from './components/campaigns/AllCampaigns'
import AssignCoupons from './components/coupons/AssignCoupons'
import DetailUniqueCampaign from './components/campaigns/DetailUniqueCampaign'
import DetailGroupCampaign from './components/campaigns/DetailGroupCampaign'
import ManageCampaign from './components/campaigns/manageCampaign/ManageCampaign'
import AllCouponHistory from './components/campaigns/campaignDetails/AllCouponHistory'




/* Error Routes */
import NoService from '@/components/layout/NoService'
import NoAccess from '@/components/layout/NoAccess'

var VueCookie = require('vue-cookie')

Vue.use(VueCookie)
Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  //store: store,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/detail-unique-campaign/:id',
      name: 'detailUniqueCampaign',
      component: DetailUniqueCampaign,
      meta: { requiresAuth: true }
    },
    {
      path: '/detail-coupon-group/:id',
      name: 'detailGroupCampaign',
      component: DetailGroupCampaign,
      meta: { requiresAuth: true }
    },
    {
      path: '/detail-coupon-history/:id',
      name: 'detailCouponHistory',
      component: AllCouponHistory,
      meta: { requiresAuth: true }
    },
    {
      path: '/assign-coupons',
      name: 'assignCoupons',
      component: AssignCoupons,
      meta: { requiresAuth: true }
    },
    {
      path: '/create-campaign',
      name: 'createCampaign',
      component: ManageCampaign,
      meta: { requiresAuth: true, access: ['campaign-administration'] }
    },
    {
      path: '/campaign/edit/:id',
      name: 'updateCampaign',
      component: ManageCampaign,
      meta: { requiresAuth: true, access: ['campaign-administration'] }
    },
    {
      path: '/sales-channels',
      name: 'allSalesChannels',
      component: AllSalesChannel,
      meta: { requiresAuth: true, access: ['sales-channel-administration'] }
    },
    {
      path: '/sales-channel/update/:salesChannelId',
      name: 'modifySalesChannel',
      component: ModifySalesChannel,
      meta: { requiresAuth: true, access: ['sales-channel-administration'] }
    },
    {
      path: '/users',
      name: 'allUsers',
      component: AllUsers,
      meta: { requiresAuth: true, access: ['user-administration','user-invitation'] }
    },
    {
      path: '/campaigns/:campaignType',
      name: 'allCampaigns',
      component: AllCampaigns,
      meta: { requiresAuth: true }
    },
    {
      path: '/products',
      name: 'allProducts',
      component: AllProducts,
      meta: { requiresAuth: true, access: ['product-administration'] }
    },
    {
      path: '/create-product',
      name: 'createProduct',
      component: CreateProduct,
      meta: { requiresAuth: true, access: ['product-administration'] }
    },
    {
      path: '/profiles',
      name: 'allProfiles',
      component: AllProfiles,
      meta: { requiresAuth: true }
    },
    {
      path: '/forgot',
      name: 'forgotPassword',
      component: ForgotPassword
    },
    {
      path: '/reinitializationPassword/:token',
      name: 'reinitializationPassword',
      component: ReinitializationPassword
    }
    ,
    {
      path: '/unauthorized',
      name: 'noAccess',
      component: NoAccess,
      meta: { requiresAuth: true }
    },
    {
      path: '/unaivailable',
      name: 'noService',
      component: NoService,
      meta: { requiresAuth: true }
    },
    {
      path: '/search',
      name: 'search',
      component: Search,
      meta: { requiresAuth: true }
    },
    {
      path: '/updatePassword',
      name: 'updatePassword',
      component: ModifyPassword,
      meta: { requiresAuth: true }
    }
    ,{
      path: '/',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: AllCampaigns
    }
  ]
})


router.beforeEach((to, from, next) => {
  // no authentication needed
  if (!to.meta.requiresAuth)
    {
    next()
    }
  //authentication needed
  else
    //user authenticated
    if (store.getters.ISAUTH)
      {
        if(to.meta.access)
          {
          if (checkPermissions(to.meta.access)) { next() } else { next('/noAccess') }
          }
        else {next()}
      }
    //user not authenticated
    else 
      {
      //user not logged
      if (!(cookie.get("mgc-u-id") != "" &&
    cookie.get("mgc-u-id") != null &&
    cookie.get("mgc-authToken") != "" &&
    cookie.get("mgc-authToken") != null
      )) {
        next('/login') }
      //user logged retrieve info
    else{
      Users.getUserById(cookie.get("mgc-u-id")).then(res => {
        store.commit("STORE_NAME",
        res.data["first-name"] + " " + res.data["name"]
      );
      Users.getProfile(res.data["user-profile-id"]).then(res => {
      store.commit("LOG_IN");
      store.commit("STORE_USERPROFILE", res.data);
    
      if (to.meta.requiresAuth && store.getters.ISAUTH == false) {
        next('/login') }
        else if (store.getters.ISAUTH == true) {
          if (to.meta.access) {
            if (checkPermissions(to.meta.access)) { next() }
            else { next('/noAccess') }
          } else { next() }
        } else { next() }
    })
  }).catch(()=>{
      next('/login') })}
}
})



// manage several permissions
function checkPermissions(permissionList) {
  for (var i = 0; i < permissionList.length; i++) {
    if (store.getters.USERPROFILE[permissionList[i]]) {
      return true
    }
  }
  return false
}


export default router
